/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputVerificationChallengeResponse
 */
export interface OutputVerificationChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof OutputVerificationChallengeResponse
     */
    challenge?: string;
}

/**
 * Check if a given object implements the OutputVerificationChallengeResponse interface.
 */
export function instanceOfOutputVerificationChallengeResponse(value: object): boolean {
    return true;
}

export function OutputVerificationChallengeResponseFromJSON(json: any): OutputVerificationChallengeResponse {
    return OutputVerificationChallengeResponseFromJSONTyped(json, false);
}

export function OutputVerificationChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputVerificationChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
    };
}

export function OutputVerificationChallengeResponseToJSON(value?: OutputVerificationChallengeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challenge': value['challenge'],
    };
}

